import { render } from "./Detail.vue?vue&type=template&id=c1e98c34"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"
script.render = render

export default script